
import React, { useEffect, useState } from "react";
import Label from "../ui/Label";
import Float from "../ui/Float";
import Menu from "../ui/Menu";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import Spin from "../ui/Spin";

export default function CustomerCustomGroups(props) {

    const { controller = "", route = "", group_nav = [], switchView = () => { }, escape = () => { }, group = "", setGroup = () => { }, groups = [], setGroups = () => { } } = props;

    const [loading, setLoading] = useState(true)

    const grps = groups.map(item => {
        return {
            text: item.name,
            count: item.count,
            option: item.name
        }
    })

    const total = grps.reduce((sum, item) => sum + item.count, 0);

    grps.unshift({
        text: "All",
        count: total,
        option: ""
    })

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { escape("customers") } },
            { key: KBD.ARROW_LEFT, action: (e) => { switchView("groups") } },
            { key: KBD.ARROW_RIGHT, action: (e) => { switchView("filters") } },
            { key: KBD.ENTER, action: (e) => { switchView("filters") } },
        ];
        const cleanup = listen(controller, route, actions.concat(group_nav), false, [KBD.ENTER]);
        return cleanup;
    }, [group]);

    
    const fetchGroups = () => {
        setLoading(true);
        pubCall("report.getReportGroupCounts", {filter: "customers"}, (_s, _r) => {
            if (_s) {
                setGroups(_r);
            } else {
                showError(_r)
            }
            setLoading(false)
        })
    }

    useEffect(fetchGroups, [props?.data?.length, group]);

    return (
        <Spin loading={loading}>
            <div style={{ "padding": "0px 15px", "marginBottom": "-10px" }}>
                <div style={{ "margin": "0px -15px" }}>{(grps.length && <Menu controller={controller} callback={(e) => setGroup(e.option)} selected={group} setSelected={(e) => setGroup(e)} showCount bordered={true} allow_keys keyName="option" menu={grps} route={route} />)}</div>
            </div>
        </Spin>
    )
    

}